import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';
import CustomReactSelect from '@Modules/core/components/form/CustomReactSelect';
import { CustomButton, CustomTextInput } from '@Modules/core/components';
import { IConsultationLogFormMeta } from '../../containers/mixtesHandlers/UsersConsultationLogDatatableHandler/UsersConsultationFormMeta';

type Props = {
  onSubmit: any,
  meta: IConsultationLogFormMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};

export default React.forwardRef(function ConsultationLogFileFormUI(
  { onSubmit, meta, isLoading, isSubmitting }: Props,
  ref
) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    reset,
  }));

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CC.Box>
          <CC.Stack px="4">
            <CC.Flex
              w="full"
              flexDirection={{ base: 'column', md: 'row' }}
              justify="space-between"
              alignItems={{ base: 'flex-start', md: 'center' }}
            >
              <CC.Box w="full" maxW="md" pr={{ base: 0, md: 4 }}>
                <CC.FormControl>
                  <CC.FormLabel htmlFor={'trader'} fontWeight={'normal'}>
                    Utilisteurs
                  </CC.FormLabel>
                  <CustomReactSelect
                    w="full"
                    isLoading={false}
                    closeMenuOnSelect={true}
                    options={meta.user.options}
                  />
                </CC.FormControl>
              </CC.Box>

              <CC.Box w="full" mt={{ base: 2, md: 0 }}>
                <CC.Text>De:</CC.Text>
                <CustomTextInput
                  meta={meta.to}
                  register={register(meta.to.name)}
                  hasError={errors[meta.to.name]}
                />
              </CC.Box>

              <CC.Box w="full" ml={{ base: 0, md: 2 }} mt={{ base: 2, md: 0 }}>
                <CC.Text>à:</CC.Text>
                <CustomTextInput
                  meta={meta.to}
                  register={register(meta.to.name)}
                  hasError={errors[meta.to.name]}
                />
              </CC.Box>
            </CC.Flex>
            <CC.Flex justify="flex-end" alignItems="center">
              <CustomButton isLoading={isSubmitting} type="submit">
                Afficher les Logs
              </CustomButton>
            </CC.Flex>
          </CC.Stack>
        </CC.Box>
      </form>
    </>
  );
});
